import { render } from "./private.vue?vue&type=template&id=0c18ab74"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"

import "./private.vue?vue&type=style&index=0&id=0c18ab74&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__